/* IDCoco · loja · v6 · comportamento comum às três páginas */
(function(){
"use strict";
var $ = function(s, r){ return (r || document).querySelector(s); };
var $$ = function(s, r){ return [].slice.call((r || document).querySelectorAll(s)); };
var reduz = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/* ---------- catálogo (tabela passada pelo cliente em 09/10) ----------
   O sachê tem preço por faixa de quantidade: até 29 sachês R$ 12,99, de 30 a 59 R$ 12,69 e a partir de 60 R$ 12,39.
   A faixa vale para a soma dos sachês de display e caixa na sacola: dois displays de 15 já pagam o preço de 30.
   Garrafa e BOX têm preço fixo. */
var PRODUTOS = {
  c15: { nome:__t("comprar.1_display_15_saches_html", "1 display · 15 sachês"), sub:__t("precos_e_cupom.rende_ate_7_5_litros_html", "Rende até 7,5 litros"), ilus:"#display-15", sachês:15 },
  c30: { nome:__t("comprar.2_displays_30_saches_html", "2 displays · 30 sachês"), sub:__t("precos_e_cupom.rende_ate_15_litros_html", "Rende até 15 litros"), ilus:"#display-15", sachês:30 },
  c60: { nome:__t("precos_e_cupom.caixa_com_4_displays_60_saches_html", "Caixa com 4 displays · 60 sachês"), sub:__t("precos_e_cupom.rende_ate_30_litros_html", "Rende até 30 litros"), ilus:"#caixa-60", sachês:60 },
  garrafa: { nome:__t("comprar.garrafa_idcoco_html", "Garrafa IDCOCO"), sub:__t("precos_e_cupom.vidro_com_as_marcas_de_37_html", "Vidro com as marcas de 37 ml e 500 ml"), preco:29.99, img:(window.__loja.assets + "garrafa-idcoco-pronta-mini.webp") },
  box: { nome:__t("comprar.box_idcoco_html", "BOX IDCOCO"), sub:__t("precos_e_cupom.caixa_presente_garrafa_e_15_saches_html", "Caixa presente, garrafa e 15 sachês"), preco:249.99, ilus:"#box-presente", vb:"18 12 386 316", frete:15 }
};
/* IDCoco Club (tabela de 10/10): pacotes de 15, 30 e 60 sachês por mês em planos de 3, 6 ou 12 meses. O valor do
   sachê é o destaque; o total do mês aparece pequeno. Toda assinatura tem frete grátis e o welcome kit com a garrafinha. */
var CLUB = { 3:{ 15:12.79, 30:12.49, 60:12.19 }, 6:{ 15:11.99, 30:11.69, 60:11.39 }, 12:{ 15:10.99, 30:10.69, 60:10.39 } };
[3, 6, 12].forEach(function(m){ [15, 30, 60].forEach(function(n){
  PRODUTOS["club" + n + "-" + m] = { nome:__t("precos_e_cupom.idcoco_club_html", "IDCoco Club ") + n + __t("precos_e_cupom.plano_de_2_html", " · plano de ") + m + __t("precos_e_cupom.meses_html", " meses"), sub:n + __t("precos_e_cupom.saches_por_mes_frete_gratis_html", " sachês por mês, frete grátis"),
    preco:Math.round(n*CLUB[m][n]*100)/100, porSache:CLUB[m][n], mensal:true, ilus:n === 60 ? "#caixa-60" : "#display-15", frete:30, club:true };
}); });
var SACHE_CHEIO = 12.99;
function precoFaixa(n){ return n >= 60 ? 12.39 : n >= 30 ? 12.69 : SACHE_CHEIO; }
/* promoção de lançamento / Black Friday (29/10): todo sachê a R$ 11,00 com o preço da faixa riscado; null volta à faixa.
   Na Shopify o preço está nas variantes (com o "comparar com") e os descontos automáticos da faixa estão desligados */
var SACHE_PROMO = 11.00;
function precoSache(n){ return SACHE_PROMO || precoFaixa(n); }
/* cupons de demonstração: na Shopify viram códigos de desconto do painel */
var CUPONS = { IDCOCO10: { pct:10, txt:"10% de desconto" }, BEMVINDO5: { pct:5, txt:"5% de desconto na primeira compra" } };
var FRETE_FIXO = 20, FRETE_GRATIS = 30;   // frete grátis a partir de 30 sachês
var LOJA = window.__loja || { variantes:{}, precos:{}, rotas:{}, idioma:"pt-BR" };
/* a loja vende em reais para todo mundo (sem Shopify Payments não há outra moeda); o formato do número segue o idioma */
var formatoMoeda = null;
try { formatoMoeda = new Intl.NumberFormat(LOJA.idioma || "pt-BR", { style:"currency", currency:"BRL" }); } catch (e) {}
function moeda(v){ v = Math.round(v*100)/100; return formatoMoeda ? formatoMoeda.format(v).replace(/\u00a0/g, " ") : "R$ " + v.toFixed(2).replace(".", ","); }
/* garrafa e BOX com o preço cadastrado na Shopify; os sachês seguem a faixa (as variantes têm o mesmo valor) */
Object.keys(LOJA.precos || {}).forEach(function(k){ if (PRODUTOS[k] && !PRODUTOS[k].sachês) PRODUTOS[k].preco = LOJA.precos[k]; });
window.IDCOCO = { PRODUTOS:PRODUTOS, moeda:moeda, precoSache:precoSache, CLUB:CLUB };

/* ---------- navegação ---------- */
var pagina = document.body.dataset.pagina || "index";
$$("[data-pagina]").forEach(function(a){
  if (a.dataset.pagina === pagina) a.setAttribute("aria-current", "page");
});
var menu = $("#menuMobile"), menuBotao = $("#menuBotao");
if (menu && menuBotao){
  menuBotao.addEventListener("click", function(){
    var aberto = menu.classList.toggle("aberto");
    menuBotao.setAttribute("aria-expanded", aberto ? "true" : "false");
  });
  $$("a", menu).forEach(function(a){ a.addEventListener("click", function(){ menu.classList.remove("aberto"); }); });
}

/* cabeçalho ganha fundo assim que a página sai do topo (na home começa transparente sobre o filme) */
var navTopo = $("#navTopo");
function estadoNav(){
  if (!navTopo) return;
  var solida = window.pageYOffset > 8 || (menu && menu.classList.contains("aberto"));
  if (navTopo.classList.contains("solida") !== solida) navTopo.classList.toggle("solida", solida);
}
addEventListener("scroll", estadoNav, { passive:true });
if (menuBotao) menuBotao.addEventListener("click", estadoNav);
estadoNav();

document.addEventListener("click", function(e){
  var d = $(".idiomas");
  if (d && d.open && !d.contains(e.target)) d.removeAttribute("open");
  if (menu && menu.classList.contains("aberto") && !menu.contains(e.target) && !menuBotao.contains(e.target)) menu.classList.remove("aberto");
});

/* ---------- sacola: o carrinho da Shopify (AJAX API) no mesmo painel do protótipo ----------
   `itens` (chave do protótipo: quantidade) é lido do carrinho, então contaSacola e os preços dos cartões seguem iguais.
   Os valores da sacola vêm da Shopify, já com os descontos automáticos da faixa e o cupom. */
var R = LOJA.rotas || {}, VAR = LOJA.variantes || {}, CHAVE_DE = {};
Object.keys(VAR).forEach(function(k){ CHAVE_DE[VAR[k]] = k; });
var carrinho = { items:[], item_count:0, items_subtotal_price:0, total_price:0 }, itens = {}, cupom = "";

/* soma da sacola: sachês de display e caixa definem a faixa de preço */
function contaSacola(extra){
  var lista = {}; Object.keys(itens).forEach(function(id){ lista[id] = itens[id]; });
  if (extra) lista[extra.id] = (lista[extra.id] || 0) + extra.q;
  var saches = 0, fretes = 0;
  Object.keys(lista).forEach(function(id){ var pr = PRODUTOS[id]; if (!pr) return; if (pr.sachês) saches += lista[id]*pr.sachês; fretes += lista[id]*(pr.sachês || pr.frete || 0); });
  var ps = precoSache(saches), sub = 0, linhas = [];
  Object.keys(lista).forEach(function(id){
    var pr = PRODUTOS[id]; if (!pr) return;
    var v = pr.sachês ? lista[id]*pr.sachês*ps : lista[id]*pr.preco;
    sub += v; linhas.push({ id:id, q:lista[id], valor:v });
  });
  return { saches:saches, fretes:fretes, ps:ps, sub:sub, linhas:linhas, itensQtd:linhas.reduce(function(t, l){ return t + l.q; }, 0) };
}
window.IDCOCO.contaSacola = contaSacola;

var sacola = $("#sacola"), veu = $("#veu"), lista = $("#sacolaItens"), vazia = $("#sacolaVazia"), subtotal = $("#subtotal");

function pedir(url, corpo){
  return fetch(url, { method: corpo ? "POST" : "GET", headers:{ "Content-Type":"application/json", "Accept":"application/json" },
    body: corpo ? JSON.stringify(corpo) : undefined }).then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); });
}
function lerCarrinho(c){
  carrinho = c; itens = {};
  (c.items || []).forEach(function(it){ var k = CHAVE_DE[it.variant_id]; if (k) itens[k] = (itens[k] || 0) + it.quantity; });
  var cod = (c.discount_codes || []).filter(function(d){ return d.applicable; })[0];
  cupom = cod ? cod.code : "";
  renderSacola(); mostrarCupom();
  return c;
}
function carregarSacola(){ return pedir(R.carrinho + ".js").then(lerCarrinho); }
function quantidade(variante, q){ var u = {}; u[variante] = q; return pedir(R.carrinho + "/update.js", { updates:u }).then(lerCarrinho); }

function renderSacola(){
  if (!sacola) return;
  var html = "", qtd = 0, deSacola = precoFaixa(contaSacola().saches);
  (carrinho.items || []).forEach(function(it){
    var k = CHAVE_DE[it.variant_id], pr = PRODUTOS[k] || { nome:it.product_title, sub:it.variant_title || "" };
    var valor = it.final_line_price/100; qtd += it.quantity;
    var mini = pr.img ? '<img src="' + pr.img + '" alt="">' : pr.ilus ? '<svg viewBox="' + (pr.vb || "0 0 320 260") + '" aria-hidden="true"><use href="' + pr.ilus + '"/></svg>' : it.image ? '<img src="' + it.image + '" alt="">' : "";
    var ps = pr.sachês ? valor/(it.quantity*pr.sachês) : 0;
    var porSache = ps ? '<small class="por-sache">' + (ps < deSacola - .001 ? '<s>' + moeda(deSacola) + '</s> ' : '') + moeda(ps) + __t("precos_e_cupom.por_sache_2_html", " por sachê") + '</small>' : '';
    html += '<li class="sacola-item" data-id="' + (k || "") + '" data-variante="' + it.variant_id + '">' +
      '<div class="mini">' + mini + '</div>' +
      '<div><b>' + pr.nome + '</b><small>' + pr.sub + '</small>' + porSache +
      '<div class="qtd"><button type="button" data-menos aria-label="Menos um">−</button><output>' + it.quantity + '</output><button type="button" data-mais aria-label="Mais um">+</button></div></div>' +
      '<div><div class="linha-valor">' + moeda(valor) + __t("precos_e_cupom.remover_2_html", "</div><button type=\"button\" class=\"remover\">Remover</button></div>") +
      '</li>';
  });
  lista.innerHTML = html;
  vazia.hidden = qtd > 0;
  sacola.classList.toggle("vazia", !qtd);
  subtotal.textContent = moeda((carrinho.items_subtotal_price || 0)/100);
  /* cupom: de pedido (cart_level) ou de produto (alocado nas linhas), a diferença entre subtotal e total cobre os dois;
     os descontos automáticos da faixa já vêm dentro do subtotal */
  var desc = Math.max(0, (carrinho.items_subtotal_price || 0) - (carrinho.total_price || 0))/100;
  var ld = $("#linhaDesconto");
  if (ld){ ld.hidden = !desc; $("#cupomNome").textContent = cupom; $("#valorDesconto").textContent = "− " + moeda(desc); }
  var lt = $("#totalSacola"); if (lt) lt.textContent = moeda((carrinho.total_price || 0)/100);
  $$("[data-conta]").forEach(function(el){ el.textContent = qtd > 0 ? qtd : ""; });
  /* frete grátis a partir de 30 sachês: a sacola mostra quanto falta e oferece o display que completa */
  var fm = $("#freteMeta");
  if (fm){
    var f = contaSacola().fretes, falta = Math.ceil(Math.max(0, FRETE_GRATIS - f)/15);
    fm.hidden = !qtd; fm.classList.toggle("ok", !falta);
    var sf = $("#sacolaFrete"); if (sf) sf.hidden = qtd > 0 && !falta;
    $("i", fm).style.width = Math.min(100, f/FRETE_GRATIS*100) + "%";
    $("p", fm).innerHTML = '<span>' + (!falta ? __t("sacola.frete_gratis_garantido_html", "<b>Frete grátis</b> garantido neste pedido.") :
      (falta === 1 ? __t("sacola.frete_falta_1_html", "Adicione mais 1 display e ganhe <b>frete grátis</b>.") : __t("sacola.frete_falta_n_html", "Adicione mais {n} displays e ganhe <b>frete grátis</b>.").replace("{n}", falta))) +
      '</span> <button type="button" class="adicionar" data-id="c15">' + __t("sacola.adicionar_1_display_html", "+ 1 display") + '</button>';
  }
  document.dispatchEvent(new CustomEvent("idcoco:sacola"));
}

/* cupom: vai para o carrinho da Shopify (/cart/update.js com discount), que diz se ele vale */
function mostrarCupom(){
  $$("[data-cupom]").forEach(function(f){
    var res = $(".cupom-res", f), inp = $("input", f);
    if (cupom){ inp.value = cupom; res.className = "cupom-res ok"; res.innerHTML = __t("precos_e_cupom.cupom_html", "Cupom <b>") + cupom + __t("precos_e_cupom.aplicado_html", "</b> aplicado.") + __t("precos_e_cupom.remover_html", " <button type=\"button\" data-tirar-cupom>Remover</button>"); }
    else if (res.classList.contains("ok")){ res.className = "cupom-res"; res.textContent = ""; inp.value = ""; }
  });
}
$$("[data-cupom]").forEach(function(f){
  f.addEventListener("submit", function(e){
    e.preventDefault();
    var cod = $("input", f).value.trim().toUpperCase().replace(/\s+/g, ""), res = $(".cupom-res", f);
    if (!cod){ res.className = "cupom-res erro"; res.textContent = __t("precos_e_cupom.digite_o_codigo_do_cupom_html", "Digite o código do cupom."); return; }
    pedir(R.carrinho + "/update.js", { discount:cod }).then(function(c){
      var vale = (c.discount_codes || []).some(function(d){ return d.code.toUpperCase() === cod && d.applicable; });
      if (vale){ lerCarrinho(c); return; }
      return pedir(R.carrinho + "/update.js", { discount:"" }).then(lerCarrinho).then(function(){
        res.className = "cupom-res erro"; res.textContent = __t("precos_e_cupom.cupom_invalido_ou_expirado_confira_o_html", "Cupom inválido ou expirado. Confira o código.");
      });
    }).catch(function(){ res.className = "cupom-res erro"; res.textContent = __t("precos_e_cupom.nao_deu_para_aplicar_o_cupom_html", "Não deu para aplicar o cupom agora. Tente de novo."); });
  });
});
document.addEventListener("click", function(e){
  if (!e.target.closest("[data-tirar-cupom]")) return;
  pedir(R.carrinho + "/update.js", { discount:"" }).then(lerCarrinho);
});

function abrirSacola(){
  if (!sacola) return;
  sacola.classList.add("aberta"); veu.classList.add("aberto");
  sacola.setAttribute("aria-hidden", "false");
  document.body.style.overflow = "hidden";
}
function fecharSacola(){
  if (!sacola) return;
  sacola.classList.remove("aberta"); veu.classList.remove("aberto");
  sacola.setAttribute("aria-hidden", "true");
  document.body.style.overflow = "";
}
$$(".abrir-sacola").forEach(function(b){ b.addEventListener("click", abrirSacola); });
$$(".fechar-sacola").forEach(function(b){ b.addEventListener("click", fecharSacola); });
if (veu) veu.addEventListener("click", fecharSacola);
addEventListener("keydown", function(e){ if (e.key === "Escape") fecharSacola(); });

/* variante de um cartão: vem do layout; se faltar (SKU ou variante trocados no painel), busca o produto na hora
   e acha pela quantidade de sachês no SKU ou no nome, para o botão nunca ficar sem adicionar */
var PRODUTO_JS = { c15:"agua-de-coco-sache", c30:"agua-de-coco-sache", c60:"agua-de-coco-sache", garrafa:"garrafa-idcoco", box:"box-idcoco" };
function resolverVariante(id){
  if (VAR[id]) return Promise.resolve(VAR[id]);
  var handle = PRODUTO_JS[id];
  if (!handle) return Promise.reject({ status:0 });
  var raiz = (R.paginas && R.paginas.index || "/").replace(/\/$/, "");
  return fetch(raiz + "/products/" + handle + ".js", { headers:{ Accept:"application/json" } })
    .then(function(r){ if (!r.ok) throw { status:r.status }; return r.json(); })
    .then(function(prod){
      var vs = prod.variants || [], n = PRODUTOS[id].sachês, v = null;
      if (n) v = vs.filter(function(x){ return ((x.sku || "") + " " + x.title).indexOf(String(n)) >= 0; })[0];
      if (!v && !n) v = vs.filter(function(x){ return x.available; })[0] || vs[0];
      if (!v) throw { status:0 };
      VAR[id] = v.id; CHAVE_DE[v.id] = id;
      if (window.console) console.warn("[IDCoco] variante de " + id + " achada pelo produto (" + v.sku + "); confira o mapa no layout");
      return v.id;
    });
}

document.addEventListener("click", function(e){
  var alvo = e.target.closest("button");
  if (!alvo) return;
  if (alvo.classList.contains("adicionar")){
    var id = alvo.dataset.id;
    if (!PRODUTOS[id]) return;
    if (PRODUTOS[id].club){   // o Club ainda não tem app de assinatura na loja
      var antes = alvo.textContent; alvo.textContent = __t("precos_e_cupom.assinaturas_em_breve_html", "Assinaturas em breve");
      setTimeout(function(){ alvo.textContent = antes; }, 2200);
      return;
    }
    var card = alvo.closest("[data-produto]"), q = 1;
    if (card){ var out = card.querySelector("[data-qtd] output"); if (out){ q = parseInt(out.textContent, 10) || 1; out.textContent = "1"; } }
    /* resposta na hora: o carrinho da Shopify leva perto de um segundo, e sem isso o clique parece não ter pegado */
    clearTimeout(alvo._volta);   // um clique novo cancela a volta do texto do clique anterior
    var rotulo = alvo.dataset.rotulo || (alvo.dataset.rotulo = alvo.textContent);
    alvo.disabled = true; alvo.textContent = __t("precos_e_cupom.adicionando_html", "Adicionando…");
    resolverVariante(id).then(function(vid){ return pedir(R.carrinho + "/add.js", { items:[{ id:vid, quantity:q }] }); }).then(carregarSacola).then(function(){
        alvo.disabled = false; alvo.textContent = __t("precos_e_cupom.adicionado_html", "Adicionado ✓"); abrirSacola();
        alvo._volta = setTimeout(function(){ alvo.textContent = rotulo; }, 1800);
      },
      function(erro){   // 422: sem estoque para essa quantidade; o resto é falha de rede ou da loja
        alvo.textContent = erro && erro.status === 422 ? __t("precos_e_cupom.sem_estoque_html", "Sem estoque") : __t("precos_e_cupom.nao_deu_para_adicionar_tente_de_novo_html", "Não deu para adicionar. Tente de novo.");
        alvo._volta = setTimeout(function(){ alvo.textContent = rotulo; alvo.disabled = false; }, 2500);
      });
    return;
  }
  var stepper = alvo.closest("[data-qtd]");
  if (stepper && !alvo.closest(".sacola-item") && (alvo.hasAttribute("data-mais") || alvo.hasAttribute("data-menos"))){
    var o = stepper.querySelector("output");
    var n = parseInt(o.textContent, 10) || 1;
    n = alvo.hasAttribute("data-mais") ? Math.min(n+1, 20) : Math.max(n-1, 1);
    o.textContent = n;
    stepper.dispatchEvent(new CustomEvent("idcoco:qtd", { bubbles:true }));
    return;
  }
  var item = alvo.closest(".sacola-item");
  if (item){
    /* pela variante da linha, não pela chave do cartão: uma variante que o tema não conhece também muda e sai */
    var vid = item.dataset.variante, atual = parseInt($("output", item).textContent, 10) || 1;
    if (!vid) return;
    if (alvo.classList.contains("remover")) quantidade(vid, 0);
    else if (alvo.hasAttribute("data-mais")) quantidade(vid, Math.min(atual+1, 20));
    else if (alvo.hasAttribute("data-menos")) quantidade(vid, atual-1);
  }
});
var finalizar = $("#finalizar");
if (finalizar) finalizar.addEventListener("click", function(){ if ((carrinho.item_count || 0) > 0) location.href = R.checkout || "/checkout"; });
carregarSacola();
/* variante sem estoque na Shopify: o botão do cartão já abre como esgotado */
var DISP = LOJA.disponivel || {};
$$(".adicionar").forEach(function(bt){
  var id = bt.dataset.id;
  if (id && VAR[id] && DISP[id] === false){ bt.disabled = true; bt.classList.add("esgotado"); bt.textContent = __t("precos_e_cupom.esgotado_html", "Esgotado"); }
});

/* links dos textos montados no JS (blog, curiosidades) apontam para as páginas do protótipo: vão para as rotas da loja */
function rotear(raiz){
  $$('a[href$=".html"], a[href*=".html?"], a[href*=".html#"]', raiz).forEach(function(a){
    var m = a.getAttribute("href").match(/^([a-z]+)\.html(.*)$/); if (!m) return;
    var destino = (R.paginas || {})[m[1]]; if (destino) a.setAttribute("href", destino + m[2]);
  });
}
rotear(document);
if ("MutationObserver" in window) new MutationObserver(function(ms){ ms.forEach(function(m){ m.addedNodes.forEach(function(n){ if (n.nodeType === 1) rotear(n.parentNode || n); }); }); })
  .observe(document.body, { childList:true, subtree:true });

/* ---------- IDCoco Club: escolha de pacote e de plano (embaixo do cupom no Comprar e na página do Club) ----------
   [data-club] tem os rádios de plano (name="...-plano") e, no Comprar, os de pacote (name="...-pacote"); cada bloco
   [data-pacote] mostra o preço daquele pacote (vazio = o pacote escolhido nos rádios) */
$$("[data-club]").forEach(function(raiz){
  function valor(nome){ var r = $('input[name="' + raiz.dataset.club + '-' + nome + '"]:checked', raiz); return r ? +r.value : 0; }
  function atualiza(){
    var m = valor("plano") || 12, escolhido = valor("pacote") || 15;
    $$("[data-pacote]", raiz).forEach(function(b){
      var n = +b.dataset.pacote || escolhido, ps = CLUB[m][n], mes = n*ps, id = "club" + n + "-" + m;
      var put = function(sel, txt){ $$(sel, b).forEach(function(el){ el.textContent = txt; }); };
      put(".js-sache", moeda(ps)); put(".js-de", moeda(SACHE_CHEIO));
      put(".js-mes", moeda(mes) + __t("precos_e_cupom.por_mes_html", " por mês"));
      put(".js-eco", __t("precos_e_cupom.economize_html", "Economize ") + moeda(n*(SACHE_CHEIO - ps)) + __t("precos_e_cupom.por_mes_html", " por mês"));
      put(".js-off", Math.round((1 - ps/SACHE_CHEIO)*100) + __t("precos_e_cupom.off_html", "% off"));
      put(".js-n", n); put(".js-plano", __t("precos_e_cupom.plano_de_html", "plano de ") + m + __t("precos_e_cupom.meses_html", " meses"));
      $$(".adicionar", b).forEach(function(bt){ bt.dataset.id = id; });
    });
  }
  raiz.addEventListener("change", atualiza);
  atualiza();
});

/* ---------- as seções entram uma vez ---------- */
var obsRev = new IntersectionObserver(function(lista){
  lista.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add("dentro"); obsRev.unobserve(e.target); } });
}, { threshold:.12, rootMargin:"0px 0px -6% 0px" });
$$(".rev").forEach(function(el){ if (reduz) el.classList.add("dentro"); else obsRev.observe(el); });

/* ---------- fundos grandes só perto da tela (05/10) ----------
   data-fundo: a foto inteira. data-fundo-cel: recorte vertical da mesma foto, com a altura inteira e o corte
   horizontal feito para a posição do background-position cair no mesmo ponto; só vale enquanto a caixa for mais
   estreita que o recorte (data-fundo-prop, largura/altura), porque aí o cover escala pela altura e o enquadramento
   fica idêntico. Fundo de CSS não tem loading="lazy", por isso o observador. */
var fundos = $$("[data-fundo]");
function fundoCerto(el){
  var cel = el.getAttribute("data-fundo-cel"), r = el.getBoundingClientRect();
  var prop = parseFloat(el.getAttribute("data-fundo-prop")) || 0;
  // o recorte foi cortado para uma posição horizontal (data-fundo-pos); se o CSS da largura atual usar outra, vai a foto inteira
  var pos = el.getAttribute("data-fundo-pos"), posAgora = getComputedStyle(el).backgroundPositionX;
  return cel && r.height && r.width / r.height < prop * .98 && (!pos || pos === posAgora) ? cel : el.getAttribute("data-fundo");
}
function porFundo(el){
  var u = fundoCerto(el);
  if (!el.getClientRects().length) return; // escondida (display:none): espera aparecer
  if (el._fundo !== u){ el._fundo = u; el.style.backgroundImage = "url('" + u + "')"; }
}
if (fundos.length){
  if ("IntersectionObserver" in window){
    var obsFundo = new IntersectionObserver(function(lista){
      lista.forEach(function(e){ if (e.isIntersecting){ porFundo(e.target); obsFundo.unobserve(e.target); } });
    }, { rootMargin:"800px 0px" });
    fundos.forEach(function(el){ obsFundo.observe(el); });
  } else fundos.forEach(porFundo);
}
/* fundo com degradê no CSS: a regra com a foto só vale com .perto */
var pertos = $$("[data-perto]");
if (pertos.length){
  if ("IntersectionObserver" in window){
    var obsPerto = new IntersectionObserver(function(lista){
      lista.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add("perto"); obsPerto.unobserve(e.target); } });
    }, { rootMargin:"800px 0px" });
    pertos.forEach(function(el){ obsPerto.observe(el); });
  } else pertos.forEach(function(el){ el.classList.add("perto"); });
}
if (fundos.length){
  var pendFundo;
  addEventListener("resize", function(){
    clearTimeout(pendFundo);
    pendFundo = setTimeout(function(){ fundos.forEach(function(el){ if (el._fundo) porFundo(el); }); }, 200);
  });
}

/* ---------- parallax leve nas dobras de foto ---------- */
var fotos = $$("[data-parallax]");
var pendParallax = false, vh = window.innerHeight;
function parallax(){
  pendParallax = false;
  var medidas = fotos.map(function(f){ return f.parentElement.getBoundingClientRect(); });
  for (var i = 0; i < fotos.length; i++){
    var r = medidas[i];
    if (r.bottom < 0 || r.top > vh) continue;
    var prog = (r.top + r.height/2 - vh/2)/vh;
    fotos[i].style.transform = "translateY(" + (prog*-7) + "%)";
  }
}
if (!reduz && fotos.length){
  addEventListener("scroll", function(){ if (!pendParallax){ pendParallax = true; requestAnimationFrame(parallax); } }, { passive:true });
  addEventListener("resize", function(){ vh = window.innerHeight; });
  parallax();
}

/* ---------- aviso de protótipo ---------- */
var aviso = $("#avisoProto");
if (aviso){
  var fechado = false;
  try { fechado = sessionStorage.getItem("idcoco-aviso") === "1"; } catch (e) {}
  if (fechado) aviso.classList.add("some");
  function fecharAviso(){
    aviso.classList.add("some");
    try { sessionStorage.setItem("idcoco-aviso", "1"); } catch (e) {}
  }
  $("button", aviso).addEventListener("click", fecharAviso);
  /* no celular e no tablet ele cobre os cartões do filme e o conteúdo, então some sozinho depois da primeira rolagem */
  if (window.innerWidth < 1280){
    var somePorScroll = function(){ if (window.pageYOffset > 320){ fecharAviso(); removeEventListener("scroll", somePorScroll); } };
    addEventListener("scroll", somePorScroll, { passive:true });
  }
}

/* ---------- página sobre ---------- */
/* o vídeo da abertura só roda sem pedido de movimento reduzido */
if (reduz) $$("video[autoplay]").forEach(function(v){ v.removeAttribute("autoplay"); v.pause(); });

/* menu da página marca a seção visível e rola sozinho no celular para mostrar o item ativo */
var local = $(".so-local");
if (local && "IntersectionObserver" in window){
  var trilhoLocal = local.firstElementChild;
  var linksLocal = $$("a", local);
  var marcarLocal = function(id){
    linksLocal.forEach(function(a){
      if (a.getAttribute("href") === "#" + id){
        a.setAttribute("aria-current", "true");
        var esq = a.offsetLeft - 24;
        if (esq < trilhoLocal.scrollLeft || a.offsetLeft + a.offsetWidth > trilhoLocal.scrollLeft + trilhoLocal.clientWidth) trilhoLocal.scrollLeft = Math.max(0, esq);
      } else a.removeAttribute("aria-current");
    });
  };
  var obsLocal = new IntersectionObserver(function(lista){
    lista.forEach(function(e){ if (e.isIntersecting) marcarLocal(e.target.id); });
  }, { rootMargin:"-35% 0px -60% 0px" });
  linksLocal.forEach(function(a){
    var alvo = document.getElementById(a.getAttribute("href").slice(1));
    if (alvo) obsLocal.observe(alvo);
  });
}


/* ---------- página IDCoco: degradê em todas as divisões de seção (02/10) ----------
   cada seção ganha no topo uma faixa que sai da cor do fim da seção anterior e some na sua; as seções com foto ou
   gradiente próprio têm a cor do fim declarada aqui, porque o fundo calculado delas é transparente */
/* o build.py já grava no HTML o resultado deste bloco (05/10) e marca o main com data-degrade; assim nada se mexe
   depois da primeira pintura. O cálculo aqui fica só para o HTML que não passou pelo build */
if (pagina === "idcoco" && !document.querySelector("main[data-degrade]")){
  /* o degradê é opaco, de uma cor à outra em oklab (o fundo de cima vira o de baixo sem passar por cinza), e cobre a
     largura toda da tela mesmo nas seções centralizadas. O rodapé também entra (02/10) */
  var main = $("main"), corMain = getComputedStyle(main).backgroundColor;
  var corDe = function(el, fim){
    if (el.classList.contains("so-sust")) return fim ? "rgb(26, 36, 25)" : "rgb(37, 50, 38)";
    if (el.classList.contains("so-hero") || el.classList.contains("ic-mundo")) return "rgb(37, 50, 38)";
    if (el.classList.contains("rodape")) return "rgb(26, 36, 25)";
    var c = getComputedStyle(el).backgroundColor;
    return /rgba\(0, 0, 0, 0\)|transparent/.test(c) ? corMain : c;
  };
  var secoes = $$("main > section"), rodape = $(".rodape");
  if (rodape) secoes.push(rodape);
  secoes.forEach(function(sec, i){
    if (i === 0) return;
    var cima = corDe(secoes[i - 1], true), baixo = corDe(sec, false);
    if (cima === baixo) return;
    sec.classList.add("com-degrade");
    /* entre um fundo claro e um escuro, a passagem atravessa os verdes da marca (sem isso, creme e verde escuro se
       misturam num cinza); entre dois claros fica a mistura simples */
    var lum = function(c){ var m = c.match(/\d+(\.\d+)?/g).map(Number); return (.2126*m[0] + .7152*m[1] + .0722*m[2])/255; };
    var lc = lum(cima), lb = lum(baixo);
    /* entre claro e escuro, a faixa mora sempre na seção escura (que tem foto ou gradiente próprio) e começa
       transparente sobre o fundo dela; o lado opaco encosta no creme, que é liso. Assim não sobra emenda (02/10) */
    if (Math.abs(lc - lb) > .4){
      sec.classList.remove("com-degrade");
      // elemento de verdade, não pseudo-elemento: as seções com textura (.grao) já usam o ::after
      var faixa = document.createElement("div"); faixa.setAttribute("aria-hidden", "true");
      // a cor vai na própria faixa: uma seção escura entre dois claros tem duas faixas, e com a variável na seção a
      // segunda sobrescrevia a primeira (a de cima terminava no creme errado e marcava a divisa)
      if (lc > lb){ sec.classList.add("entra-claro"); faixa.style.setProperty("--claro", cima); faixa.className = "faixa-transicao topo"; sec.insertBefore(faixa, sec.firstChild); }
      else { var ant = secoes[i - 1]; ant.classList.add("sai-claro"); faixa.style.setProperty("--claro", baixo); faixa.className = "faixa-transicao base"; ant.appendChild(faixa); }
    }
    sec.style.setProperty("--cor-cima", cima);
    sec.style.setProperty("--cor-baixo", baixo);
  });
}

/* cartas de curiosidade: no toque (celular, sem hover) viram e desviram */
$$(".ic-curio-cartas li").forEach(function(li){ li.addEventListener("click", function(){ li.classList.toggle("virada"); }); });

/* ---------- página de produto ----------
   13/10: a ficha é uma vitrine de cartões (.kit[data-produto]); cada um tem quantidade e botão próprios. O valor do
   sachê acompanha a quantidade do cartão somada ao que já está na sacola, então 2 displays de 15 já mostram o preço de 30 */
var pdp = $("#pdp");
if (pdp){
  var kits = $$(".kit[data-produto]", pdp);
  function qtdDe(card){ var o = card && $("[data-qtd] output", card); return o ? parseInt(o.textContent, 10) || 1 : 1; }
  function precoKit(card){
    var id = card.dataset.produto, pr = PRODUTOS[id], el = $("[data-valor]", card); if (!pr || !el) return;
    var q = qtdDe(card);
    if (pr.sachês){
      var n = q*pr.sachês, cs = contaSacola({ id:id, q:q }), ps = cs.ps, de = precoFaixa(cs.saches), gratis = contaSacola({ id:id, q:q }).fretes >= FRETE_GRATIS;
      el.innerHTML = (SACHE_PROMO ? '<span class="tag-bf">' + __t("precos_e_cupom.black_friday_html", "Black Friday") + '</span>' : '') + (ps < de ? __t("precos_e_cupom.de_html", "<span class=\"kit-de\">de <s>") + moeda(de) + __t("precos_e_cupom.por_html", "</s> por:</span>") : __t("precos_e_cupom.por_apenas_2_html", "<span class=\"kit-de\">por apenas</span>")) +
        '<strong>' + moeda(ps) + __t("precos_e_cupom.por_sache_html", "</strong><span class=\"kit-un\">por sachê</span>") +
        '<small>' + (q > 1 ? q + (id === "c60" ? __t("precos_e_cupom.caixas_html", " caixas") : id === "c30" ? __t("precos_e_cupom.kits_de_2_displays_html", " kits de 2 displays") : __t("precos_e_cupom.displays_html", " displays")) + " · " + n + __t("precos_e_cupom.saches_html", " sachês · ") : "") + moeda(n*ps) + __t("precos_e_cupom.no_total_html", " no total") + (gratis ? __t("precos_e_cupom.frete_gratis_html", " · frete grátis") : '') + '</small>' +
        (gratis ? '' : '<span class="kit-frete">' + __t("precos_e_cupom.leve_mais_frete_1_html", "Leve mais 1 display e o frete sai grátis") + '</span>');
    } else {
      el.innerHTML = '<span class="kit-de">' + (id === "box" ? __t("precos_e_cupom.presente_completo_html", "presente completo") : __t("precos_e_cupom.por_apenas_html", "por apenas")) + '</span><strong>' + moeda(q*pr.preco) + '</strong>' +
        (q > 1 ? '<small>' + q + __t("precos_e_cupom.texto_html", " × ") + moeda(pr.preco) + '</small>' : '');
    }
  }
  function precosKits(){ kits.forEach(precoKit); }
  precosKits();
  pdp.addEventListener("idcoco:qtd", function(e){ var c = e.target.closest(".kit[data-produto]"); if (c) precoKit(c); });
  document.addEventListener("idcoco:sacola", function(){ setTimeout(precosKits, 0); });   // o botão volta a quantidade para 1 e a sacola muda a faixa
  /* links da home (comprar.html?formato=c60) e da calculadora: o cartão pedido ganha destaque */
  var pedido = new URLSearchParams(location.search).get("formato");
  var alvoKit = pedido && $('.kit[data-produto="' + pedido + '"]', pdp);
  if (alvoKit){ alvoKit.classList.add("pedido"); setTimeout(function(){ alvoKit.classList.remove("pedido"); }, 2600); }

}
})();
